export const CookieConstants = {
  MILBHUB_BLUE_COOKIE: "best-blue-milbhub-integration",
};
